<template>
  <ProSpaceHLayout
    justify-content="space-between"
    class="address-program__footer"
  >
    <div class="address-program__footer-block">
      <div class="footer-block__row">
        {{ $t('totalOutlets') }}
        <ProSpaceTag
          type="gray-light"
          :text="storeAmount || 0"
          bordered
          style="height: 18px"
        />
      </div>
      <div class="footer-block__row">
        {{ $t('budget') }}
        <ProSpaceTag
          type="gray-light"
          :text="getBudget || 0"
          bordered
          style="height: 18px"
        />
      </div>
    </div>
  </ProSpaceHLayout>
</template>

<script>
import {
  ProSpaceHLayout,
  ProSpaceTag
} from "@prospace/prospace-components-library";
export default {
  name: "AddressProgramOrderFooter",
  components: {
    ProSpaceHLayout,
    ProSpaceTag
  },
  props: {
    storeAmount: {
      type: Number
    },
    budget: {
      type: Number
    },
    formatter: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    getBudget() {
      if (this.formatter) {
        return this.formatter(this.budget || 0, ".");
      } else {
        return this.budget || 0;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.address-program {
  &__footer {
    display: flex;
    padding: 10px 15px;
    background: var(--prospace-ui-gray-card-bg) !important;
    border-top: 1px solid var(--prospace-ui-border-color);
    &-block {
      display: grid;
      gap: 20px;
      grid-template-columns: auto auto;
      .prospace-tag {
        margin-left: 5px;
        font-weight: 400;
      }
      .footer-block {
        &__row {
          display: grid;
          grid-template-columns: auto auto;
          align-items: center;
          font-size: 12px;
          color: var(--prospace-text-gray);
        }
        &__indicator {
          height: 12px;
          width: 12px;
          border-radius: 3px;
          background-color: #BECBD0;
          margin-left: 5px;
          &--fact {
            background-color: #5EA6DF;
          }
        }
      }
    }
  }
}
</style>
